import type { ChessStats } from "../models/stats/stats-model";
import { db } from "./db";

export const CollectionStatsRepository = {
    async get(collectionId: string): Promise<ChessStats | undefined> {
        return db.collectionStats.get(collectionId);
    },

    async save(stats: ChessStats): Promise<void> {
        await db.collectionStats.put(stats);
    },

    async remove(collectionId: string): Promise<void> {
        await db.collectionStats.delete(collectionId);
    },
};
